import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { LayoutAnonymous as Layout } from '../LayoutAnonymous';
import { parseURL } from '../../Utils/Utils';

const AuthenticationRoutes = ({ component: Component, ...rest }) => {
  const { path } = rest;
  const { isAuthenticated, redirectTo } = rest.auth;
  const { pathname, search } = parseURL(redirectTo);

  return isAuthenticated ? (
    <Redirect
      to={{
        pathname,
        search,
        state: { from: redirectTo }
      }}
    />
  ) : (
    <Layout exact path={path} component={Component} isAuthenticated={isAuthenticated} />
  );
};

AuthenticationRoutes.propTypes = {
  component: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  auth: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    redirectTo: PropTypes.string
  })
};

AuthenticationRoutes.defaultProps = {
  auth: {
    loading: undefined,
    isAuthenticated: undefined,
    redirectTo: undefined
  }
};

const mapStateToProps = state => ({
  auth: state.toJS().auth
});

export default connect(mapStateToProps)(AuthenticationRoutes);
